<template>
  <div class="col">
    <v-row align="center" justify="center" class="my-5">
      <v-img v-if="loggedUser && loggedUser.ground && loggedUser.ground.logo"
        :src="svgLogo" alt="Logo do cliente"
        :max-width="$vuetify.breakpoint.xsOnly ? '150' : ($vuetify.breakpoint.smOnly ? '200' : '300')"
        class=""
        contain
      />
      <v-img v-else
        :src="require('@assets/logo/Logo_SemFundo_Agrosim_reduzido.png')" alt="AgroSim"
        :max-width="$vuetify.breakpoint.xsOnly ? '150' : ($vuetify.breakpoint.smOnly ? '200' : '300')"
        class=""
        contain
      />
    </v-row>
    <v-row align="center" justify="center">
      <div>
        Olá, <b>{{loggedUser ? (loggedUser.person ? loggedUser.person.name : 'cliente AgroSim') : 'cliente AgroSim'}}</b>. 
      </div>
    </v-row>
    <v-row align="center" justify="center">
      <div class="d-none d-md-block">
        Seja bem-vindo à sua plataforma de gestão agrícola.
      </div>
      <div class="d-md-none mt-10 text-center text-h6 text--secondary">
        Seja bem-vindo à sua plataforma de <b>gestão agrícola</b>.
        <br>
        Tudo que você precisa <b>na palma da sua mão</b>.
      </div>
    </v-row>
    <v-row class="d-none d-md-flex">
      <v-col cols="12">
        <v-carousel
          cycle
          interval="25000"
          height="400"
          width="80%"
          hide-delimiter-background
          show-arrows-on-hover
          class="mt-5"
        > 
          <v-carousel-item>
            <v-sheet
              height="100%"
              color="white"
            >
              <v-row
                class="fill-height"
              >
                <v-col md="3" class="d-none d-md-flex">
                  <v-img
                    :src="require('@assets/home_images/banner4.png')" alt="Banner 4"
                    class=""
                    contain
                  />
                </v-col>
                <v-col sm="12" md="9">
                  <div class="mx-sm-10 my-sm-10">
                    <div class="display-1 black--text">
                      Lançamos o app AgroSim!
                    </div>
                    <p class="headline grey--text my-5 mx-5">
                      Agora você pode fazer e ter acesso a todo o controle da sua propriedade na palma da sua mão. 
                      Lançamos o app <b>AgroSim</b> para smartphones Android e Apple. 
                      Você já pode procurar na sua loja de aplicativos pelo app AgroSim e fazer o download. 
                      Depois, basta acessar com o seu login e todos os seus dados estarão disponíveis para você, de forma simples e prática!
                      Ah, e não esqueça de deixar sua avaliação e um comentário lá na loja de apps!
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>

          <v-carousel-item>
            <v-sheet
              height="100%"
              color="white"
            >
              <v-row
                class="fill-height"
              >
                <v-col md="3" class="d-none d-md-flex">
                  <v-img
                    :src="require('@assets/home_images/banner1.png')" alt="Banner 1"
                    class=""
                    contain
                  />
                </v-col>
                <v-col sm="12" md="9">
                  <div class="mx-sm-10 my-sm-10">
                    <div class="display-1 black--text">
                      Simplificando a gestão do campo!
                    </div>
                    <p class="headline grey--text my-5 mx-5">
                      Nós da equipe <b>AgroSim</b> estamos trabalhando intensamente para fazer desta plataforma o seu braço direito na gestão do seu negócio.
                      A cada dia estamos planejando e reinventando a nossa plataforma para que ela possa atender e superar suas necessidades do dia-a-dia.
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>

          <v-carousel-item>
            <v-sheet
              height="100%"
              color="white"
            >
              <v-row
                class="fill-height"
              >
                <v-col sm="12" md="8">
                  <div class="mx-sm-10 my-sm-10">
                    <div class="display-1 black--text">
                      Simplificando a tecnologia para gestão!
                    </div>
                    <p class="headline grey--text my-5 mx-5">
                      Estamos lançando esta nova versão do sistema, com mais tecnologia, mais inteligência e mais praticidade.
                      Assim, estaremos lançando nossas novidades e atualizações constantemente, para tornar a sua vida no campo mais produtiva e menos burocrática.
                    </p>
                  </div>
                </v-col>
                <v-col md="4" class="d-none d-md-flex">
                  <v-img
                    :src="require('@assets/home_images/banner2.png')" alt="Banner 2"
                    class=""
                    contain
                  />
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
 data () {
  return {
    loggedUser: {},
    svgLogo: null,
  }
 },
 created(){
   this.getCurrentUser(user => {
      this.loggedUser = user;
      // console.log('loggedUser index', this.loggedUser);
      if (user && user.ground && user.ground.logo) {
        // Encode the raw SVG string safely for use in a Data URL
        const encoded = encodeURIComponent(this.loggedUser.ground.logo)
        .replace(/'/g, '%27')
        .replace(/"/g, '%22');
        this.svgLogo = `data:image/svg+xml;charset=utf-8,${encoded}`;
      }
    });
 }
}
</script>

<style scoped>

</style>
